module.exports = "/images/vendor/flag-icon-css/flags/1x1/cm.svg?c972441e6e4522441d18c0390c143d32";